import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Select from '../Select';
import Text from '../Text';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

class SelectorQuestion extends Component {
  state = { answerIs: null };

  updateAnswer = (answerIs, answers) => this.setState({ answerIs, answers });

  render() {
    const {
      answerIs,
    } = this.state;
    const {
      question,
      goal,
      form,
      onFocus,
      onChange,
      onBlur,
      onQuestionChange,
      goToNextInput,
      injectNewQuestions,
      removeNewQuestions,
      selectorStyle,
    } = this.props;
    const {
      maxQuestions,
    } = question;
    return (
      <StyledContainer>
        <Text type="questionText">{question.startText}</Text>
        <Select
          id={question.id}
          className={`question ${goal.value}`}
          // autoFocus={question.index === 0 && goal.index === 0}
          name={question.inputName}
          value={form.values[question.inputName]}
          placeholder={question.placeholder}
          options={question.answers}
          onOptionSelected={(value) => {
            onQuestionChange(value);
            // First time user answers this question
            if (answerIs === null) {
              this.updateAnswer(value, value.extraQuestions);
              let extraQuestions = 0;
              if (value.extraQuestions) {
                extraQuestions = value.extraQuestions.length;
              }
              let maxQuestionsTemp = 0;
              if (maxQuestions) {
                maxQuestionsTemp = maxQuestions;
              }
              injectNewQuestions(
                value.extraQuestions,
                goal.index,
                question.index,
                (maxQuestionsTemp - extraQuestions),
                () => {
                  goToNextInput(question.id);
                },
              );
            } else if (value !== answerIs) {
              let extraQuestions = 0;
              if (value.extraQuestions) {
                extraQuestions = value.extraQuestions.length;
              }
              let maxQuestionsTemp = 0;
              if (maxQuestions) {
                maxQuestionsTemp = maxQuestions;
              }
              removeNewQuestions(
                goal.index,
                question.index,
                -(maxQuestionsTemp - extraQuestions),
                () => {
                  this.updateAnswer(value, value.extraQuestions);
                  injectNewQuestions(
                    value.extraQuestions,
                    goal.index,
                    question.index,
                    (maxQuestionsTemp - extraQuestions),
                    () => {
                      goToNextInput(question.id);
                    },
                  );
                },
              );
            }
          }}
          onChange={(ev) => {
            form.handleChange(ev);
            form.setFieldTouched(question.inputName);
            form.validateForm(form.values);
            onChange(ev, { form, inputName: question.inputName });
          }}
          onFocus={ev => onFocus(ev, question.index, goal.value, form)}
          onBlur={(ev) => {
            form.handleBlur(ev);
            onBlur(ev, {
              values: form.values,
              goalName: goal.value,
              goalAnswered: goal.isAnswered,
              goalIndex: goal.index,
            });
          }}
          style={selectorStyle}
        />
        <Text type="questionText">{question.endText}</Text>
      </StyledContainer>
    );
  }
}

SelectorQuestion.propTypes = {
  question: PropTypes.object,
  goal: PropTypes.object,
  form: PropTypes.object,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onQuestionChange: PropTypes.func,
  onBlur: PropTypes.func,
  injectNewQuestions: PropTypes.func,
  removeNewQuestions: PropTypes.func,
  goToNextInput: PropTypes.func,
  selectorStyle: PropTypes.object,
};

SelectorQuestion.defaultProps = {
  question: {},
  goal: {},
  form: {},
  onFocus: () => {},
  onChange: () => {},
  onQuestionChange: () => {},
  onBlur: () => {},
  injectNewQuestions: () => {},
  removeNewQuestions: () => {},
  goToNextInput: () => {},
  selectorStyle: {},
};


export default SelectorQuestion;
